import {map} from 'rxjs/operators';
import {sessionInfoSetAction} from 'module/SessionInfo/action/SessionInfoAction';
import {sessionInfo$} from 'module/SessionInfo/api/SessionInfoAPI'
import {combineEpics} from 'redux-observable';
import {EvoAppsUserInfoTO} from 'generated/JavaTO';

const DataEpic = () => sessionInfo$.pipe(map((data: EvoAppsUserInfoTO | null) => sessionInfoSetAction(data)));

export const SessionInfoEpic = combineEpics(DataEpic);
